/**
 * Pure function. Given a 0..48 start index, return the full reading.
 * Derives collectedLetters at runtime from paths + grid.
 */
export default function deriveHanumanReading(startIndex, data) {
  if (!Number.isInteger(startIndex) || startIndex < 0 || startIndex > 48) {
    throw new RangeError(`startIndex must be an integer in [0, 48], got ${startIndex}`);
  }
  const pathCells = data.paths[startIndex];
  if (!Array.isArray(pathCells) || pathCells.length !== 7 || pathCells[0] !== startIndex) {
    throw new Error(`paths[${startIndex}] must be length-7 array with path[0] === ${startIndex}`);
  }
  const verse = data.verses[startIndex];
  if (!verse || typeof verse.verse_sa !== 'string' || typeof verse.verse_ta !== 'string') {
    throw new Error(`verses[${startIndex}] is missing or malformed`);
  }
  const collectedLetters = pathCells.map(i => data.grid[i]).join('');
  const collectedLettersTa = pathCells.map(i => data.grid_ta[i]).join('');
  return {
    startIndex,
    pathCells,
    collectedLetters,
    collectedLettersTa,
    verse: verse.verse_sa,
    verse_ta: verse.verse_ta,
    interpretation_ta: verse.interpretation_ta,
    interpretation_en: verse.interpretation_en,
    chalisaLineNumber: verse.chalisaLineNumber,
  };
}
